import instantsearch from 'instantsearch.js';
import algoliasearch from "algoliasearch";
import {
	configure,
	infiniteHits,
	// pagination,
	searchBox,
	stats,
	// currentRefinements,
	clearRefinements,
	refinementList,
	menuSelect,
	menu,
	sortBy,
} from 'instantsearch.js/es/widgets';
import { connectInfiniteHits, connectClearRefinements } from 'instantsearch.js/es/connectors'

export class ResourceSearch {
	//This handles resources and webinar
	constructor() {
	}

	init() {
		let searchConfig = {
			'results_text': 'Results',
			'index': 'resources',
			'template': window.MEFA_SEARCH_RESULT_TEMPLATE
		}

		//add the data-term,category,type to the end of the href of all .resource-view-all-link
		document.querySelectorAll('.resource-view-all-link').forEach(el => {
			const term = el.getAttribute('data-term');
			const category = el.getAttribute('data-category');
			const type = el.getAttribute('data-type');
			const href = el.getAttribute('href');
			let extra = "";
			if(href.indexOf('?') === -1){
				extra += "?";
			}
			if(category){
				extra += `${window.ALGOLIA_INDEX_PREFIX}${searchConfig.index}%5Bmenu%5D%5Bcategory%5D=${category}&`;
			}
			if(term){
				extra += `${window.ALGOLIA_INDEX_PREFIX}${searchConfig.index}%5Bmenu%5D%5Btopic%5D=${term}&`
			}
			if(type){
				extra += `${window.ALGOLIA_INDEX_PREFIX}${searchConfig.index}%5Bmenu%5D%5Btype%5D=${type}&`;
			}
			el.setAttribute('href', `${href}${extra}`);
		});


		let lastRenderArgs;
		const resourceFilterSection = document.querySelector('.resource-filter-section');
		if (!resourceFilterSection) {
			return;
		}

		let searchType = resourceFilterSection.querySelector('.container').dataset.filterType;
		if(!searchType){
			return;
		}
		if(searchType === 'webinar'){
			searchConfig.results_text = 'Upcoming';
			searchConfig.index = 'webinars';
			searchConfig.template = window.MEFA_WEBINAR_SEARCH_RESULT_TEMPLATE;
		}
		const searchTemplate = searchConfig.template;
		if (!searchTemplate) {
			console.error('Missing search template');
			return;
		}

		if(!document.querySelector('#resources-search-results')){
			return;
		}

		function checkResourceSearchQueryParams() {
			if(searchConfig.index === 'webinars'){
				document.body.classList.add('resource-search-active');
			}else{
				if (window.location.search.indexOf(window.ALGOLIA_INDEX_PREFIX + searchConfig.index) !== -1) {
					document.body.classList.add('resource-search-active');
				} else {
					document.body.classList.remove('resource-search-active');
				}
			}
		}
		checkResourceSearchQueryParams();

		let storageKey = 'mefa-favorites';
		//favorites changed. trigger favorite search if that is the active topic filter
		window.addEventListener('localStorageChange', (e) => {
			if (e.detail?.storageKey === storageKey && window.location.search.indexOf('topic%5D=Favorites') !== -1) {
				this.doFavoriteSearch();
			}
		});

		const facetOrder = ['All Topics', 'Announcements', 'Planning', 'Saving', 'Paying', 'Favorites'];

		//this is supposed to lazy load the next page when you reach the bottom of the results. not loading consistently
		const customInfiniteHits = connectInfiniteHits(
			(renderArgs, isFirstRender) => {
				const { items, showMore, widgetParams } = renderArgs;
				const { container } = widgetParams;
				const containerObj = document.querySelector(container);

				lastRenderArgs = renderArgs;

				if (isFirstRender) {
					const sentinel = document.createElement('div');
					// containerObj.appendChild(document.createElement('ul'));
					containerObj.appendChild(sentinel);

					const observer = new IntersectionObserver(entries => {
						entries.forEach(entry => {
							if (entry.isIntersecting && !lastRenderArgs.isLastPage) {
								console.log("getting more");
								showMore();
							}
						});
					});

					observer.observe(sentinel);

					return;
				}
			}
		);


		const renderClearRefinements = (renderOptions, isFirstRender) => {
			const { createURL, canRefine } = renderOptions;

			if (!isFirstRender && canRefine) {
				document.querySelector('#resources-clear').innerHTML = `
					<a href=${createURL()}>Clear</a>
				`;
			}
			if(!canRefine){
				document.querySelector('#resources-clear').innerHTML = ``;
			}
		};

		const customClearRefinements = connectClearRefinements(
			renderClearRefinements
		);

		const pastWebinarFilter = (category) => {
			const cards = document.querySelectorAll('.related-resources .card');
			let count = 0;
			cards.forEach(card => {
				const categories = card.dataset.categories.split(',').map(c => c.trim());
				const visible = category.length === 0 || categories.some(c => category.includes(c));
				card.style.display = visible ? '' : 'none';
				if(!visible){
					count++;
				}
			});
			if(count === cards.length){
				document.querySelector('.related-resources').classList?.add('no-webinar-results');
			}else{
				document.querySelector('.related-resources').classList?.remove('no-webinar-results');
			}
		}


		let local = this;
		const search = instantsearch({
			indexName: window.ALGOLIA_INDEX_PREFIX + searchConfig.index,
			searchClient: algoliasearch(
				window.ALGOLIA_APP_ID,
				window.ALGOLIA_KEY
			),
			future: {
				preserveSharedStateOnUnmount: true
			},
			initialUiState: {
				[window.ALGOLIA_INDEX_PREFIX + searchConfig.index]: {
					// "menu": {"topic": "All Topics"}
				}
			},
			onStateChange({ uiState, setUiState }) {
				// console.log(uiState);
				setUiState(uiState);
				setTimeout(() => {
					checkResourceSearchQueryParams();
				}, 500);
			},
			routing: true,
			searchFunction(helper) {
				if(helper.state?.hierarchicalFacetsRefinements?.topic?.includes('Favorites')){
					local.doFavoriteSearch();
				}else{
					document.querySelector('#resources-search-results').style.display = 'block';
					document.querySelector('#resources-favorites-results').style.display = 'none';

					document.querySelector('#resources-favorites-stats').style.display = 'none';
					document.querySelector('#resources-search-stats').style.display = 'block';
					document.querySelector('#mobile-resources-search-stats').style.display = 'block';
					document.querySelector('.resource-filter-section .filters').style.display = 'flex';
				}
				if(searchConfig.index === 'webinars'){
					const now = Math.floor(Date.now() / 1000);
					helper.setQueryParameter('filters', `event_date_unix >= ${now}`);

					pastWebinarFilter(helper.state?.hierarchicalFacetsRefinements?.category);
				}
				helper.search();
			}
		});

		search.addWidgets([
			configure({
				hitsPerPage: 24,
			}),
			stats({
				container: '#resources-search-stats',
				templates: {
					text(data, { html }) {
						if (data.hasManyResults || data.hasOneResult) {
							return html`<h2>${searchConfig.results_text} (${data.nbHits})</h2>`;
						}
						return html`<h2>${searchConfig.results_text} (0)</h2>`;
					}
				}
			}),
			stats({
				container: '#mobile-resources-search-stats',
				templates: {
					text(data, { html }) {
						if (data.hasManyResults || data.hasOneResult) {
							return html`<span>${searchConfig.results_text} (${data.nbHits})</span>`;
						}
						return html`<span>${searchConfig.results_text} (0)</span>`;
					}
				}
			}),
			sortBy({
				container: '#resources-sortBy',
				items: [
					{ label: 'Sort By', value: window.ALGOLIA_INDEX_PREFIX + searchConfig.index },
					{ label: 'Most Recent', value: window.ALGOLIA_INDEX_PREFIX + searchConfig.index+'_recent' },
					{ label: 'Least Recent', value: window.ALGOLIA_INDEX_PREFIX + searchConfig.index+'_least_recent' },
				],
				cssClasses: {
					select: 'content-type form-select',
				}
			}),
			sortBy({
				container: '#mobile-filter-sortBy',
				items: [
					{ label: 'Sort By', value: window.ALGOLIA_INDEX_PREFIX + searchConfig.index },
					{ label: 'Most Recent', value: window.ALGOLIA_INDEX_PREFIX + searchConfig.index + '_recent' },
					{ label: 'Least Recent', value: window.ALGOLIA_INDEX_PREFIX + searchConfig.index + '_least_recent' },
				],
				cssClasses: {
					select: 'content-type form-select',
				}
			}),
			menu({
				container: '#resources-filter-topic',
				attribute: 'topic',
				sortBy(a, b) {
					const aIndex = facetOrder.indexOf(a.name);
					const bIndex = facetOrder.indexOf(b.name);
					if (aIndex !== -1 && bIndex !== -1) {
						return aIndex - bIndex;
					} else if (aIndex !== -1) {
						return -1;
					} else if (bIndex !== -1) {
						return 1;
					} else {
						if (a < b) {
							return -1;
						} else if (a > b) {
							return 1;
						} else {
							return 0;
						}
					}
				},
			}),
			menuSelect({
				container: '#mobile-filter-topics',
				attribute: 'topic',
				limit: 100,
				ariaLabel: 'Topic',
				templates: {
					defaultOption(data, { html }) {
						return html`<span>Content Topic</span>`;
					},
					item(item, { html }) {
						// - (${item.count.toLocaleString()})
						return html`<span>${item.label}</span>`;
					},
				},
				cssClasses: {
					select: 'content-type form-select',
				}
			}),
			menuSelect({
				container: '#resources-filter-type',
				attribute: 'filter_content_type',
				limit: 100,
				templates: {
					defaultOption(data, { html }) {
						return html`<span>Content Type</span>`;
					},
					item(item, { html }) {
						// - (${item.count.toLocaleString()})
						return html`<span>${item.label}</span>`;
					},
				},
				cssClasses: {
					select: 'content-type form-select',
				}
			}),
			menuSelect({
				container: '#mobile-filter-type',
				attribute: 'type',
				limit: 100,
				templates: {
					defaultOption(data, { html }) {
						return html`<span>Content Type</span>`;
					},
					item(item, { html }) {
						// - (${item.count.toLocaleString()})
						return html`<span>${item.label}</span>`;
					},
				},
				cssClasses: {
					select: 'content-type form-select',
				}
			}),


			menuSelect({
				container: '#resources-filter-category',
				attribute: 'category',
				limit: 100,
				templates: {
					defaultOption(data, { html }) {
						return html`<span>Category</span>`;
					},
					item(item, { html }) {
						// - (${item.count.toLocaleString()})
						return html`<span>${item.label}</span>`;
					},
				},
				cssClasses: {
					select: 'content-type form-select',
				}
			}),
			menuSelect({
				container: '#mobile-filter-category',
				attribute: 'category',
				limit: 100,
				templates: {
					defaultOption(data, { html }) {
						return html`<span>Category</span>`;
					},
					item(item, { html }) {
						// - (${item.count.toLocaleString()})
						return html`<span>${item.label}</span>`;
					},
				},
				cssClasses: {
					select: 'content-type form-select',
				}
			}),



			//clear all filters
			// customClearRefinements({
			// 	container: '#resources-clear',
			// }),
			clearRefinements({
				container: '#resources-clear',
				templates: {
					resetLabel: '<i class="icon-close2"></i> Clear',
				},
			}),
			infiniteHits({
				container: "#resources-search-results",
				cssClasses: {
					list: 'cards-list ',
					loadMore: 'btn btn-primary',
				},
				transformItems2: (items) => {
					//if we are doing a favorite search only get the ones that are liked. we would need to get all resources at once for this to work
					const favorites = JSON.parse(localStorage.getItem('mefa-favorites')) || [];
					return items.filter(item => favorites.includes(item.objectID.replace('resource#', '')+''));
					return items;
				},
				templates: {
					empty(results, { html }) {
						return html`<div class="no-results">No results found for <q>${results.query}</q><p></p></div>`;
					},
					item(hit, { html, components }) {
						// console.log(hit);
						let id = hit.objectID;
						let topic = "";
						if(hit.topic !== null){
							if(hit.topic !== null){
								hit.topic = hit.topic.filter(topic => topic !== "All Topics" && topic !== "Favorites");
								if(hit.topic.length > 0){
									topic = hit.topic[0];
								}
							}
						}
						id = id.replace('resource#', '');
						let date = hit.date;
						if(searchConfig.index === 'webinars'){
							date = hit.event_date+' '+hit.event_time;
						}
						if(searchConfig.index === 'webinars'){
							date = hit.event_date+' '+hit.event_time;
							if(hit.multi_event === true){
								date = "Multiple Dates";
							}
						}
						if(hit.read_time === null){hit.read_time = "";}
						let read_text = "";
						let read_icon = "";
						let read_type = "";
						let webinar_link = "";
						if(hit.type === 'Webinar'){
							read_type = "";
							read_icon = "icon-identification-card";
							webinar_link = hit.event_link || "";
						}
						else if(hit.type === 'Podcast'){
							read_type = "listen";
							read_icon = "icon-microphone";
						}
						else if(hit.type === 'Article' || hit.type === 'Resource' || hit.type === 'Page' || hit.type === 'Tertiary' || hit.type === 'Lesson'){
							read_type = "read";
							read_icon = "icon-book-open-text";
						}
						else if(hit.type === 'Video'){
							read_type = "video";
							read_icon = "icon-video";
						}
						if(hit.filter_content_type !== null && (hit.filter_content_type == "Career Planning" || hit.filter_content_type == "PDF Guide" || hit.filter_content_type == "Calculator" || hit.filter_content_type == "Lesson")){
							read_type = "";
						}
						read_text = `<strong class="text-icon"><span class="${read_icon}"></span></strong>`
						if(hit.read_time !== ""){
							read_text = `<strong class="text-icon"><span class="${read_icon}"></span> ${hit.read_time} ${read_type}</strong>`
						}
						let result = searchTemplate
							.replaceAll("{{id}}", id)
							.replaceAll("{{title}}", hit.title)
							.replaceAll("{{link}}", hit.url)
							.replaceAll("{{image}}", hit.image)
							.replaceAll("{{category}}", topic)//hit.category
							.replaceAll("{{date}}", date)
							.replaceAll("{{read_time}}", read_text)
							.replaceAll("{{webinar_link}}", webinar_link)
							;
						if(hit.type === "Podcast"){
							result = result.replaceAll('<span class="card__date"> </span>', `<span class="card__date">${hit.date}</span>`);
						}
						return html`${result}`;
					},
				},
			}),
			// customInfiniteHits({
			// 	container: "#resources-search-results",
			// })
		]);


		search.on('render', () => {
			if (search.helper?.lastResults?.hits.length === 0) {
				// document.querySelector('.search-drop__bottom-block').classList.add("no-results-found");
			} else {
				// document.querySelector('.search-drop__bottom-block').classList.remove("no-results-found");
			}
			if(search.helper?.state?.hierarchicalFacetsRefinements?.topic.length === 0){
				//no topic selected. toggle all topics to on
				document.querySelector('#resources-filter-topic li:nth-child(1)')?.classList.add('ais-Menu-item--selected');
			}else{
				if(!search.helper?.state?.hierarchicalFacetsRefinements?.topic.includes('All Topics')){
					document.querySelector('#resources-filter-topic li:nth-child(1)')?.classList.remove('ais-Menu-item--selected');
				}
			}


			/*
			if (document.querySelector('#resources-filter-topic .ais-Menu-list') && !document.querySelector('#mobile-filter-topics') ) {
				this.initMobileInterface();
			}*/

		});

		search.start();

		this.initMobileInterface();
	} // end init

	async doFavoriteSearch(){
		document.querySelector('#resources-search-results').style.display = 'none';
		document.querySelector('#resources-favorites-results').style.display = 'block';

		document.querySelector('#resources-favorites-stats').style.display = 'block';
		document.querySelector('#resources-search-stats').style.display = 'none';
		document.querySelector('.resource-filter-section .filters').style.display = 'none';

		const options = {
			method: 'POST',
			credentials: 'same-origin',
			headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
			body: 'action=getcards'
		}

		const favorites = JSON.parse(localStorage.getItem('mefa-favorites')) || [];
		if(favorites.length === 0){
			document.querySelector('#resources-favorites-stats').innerHTML = '<h2>Results (0)</h2>';
			document.querySelector('#resources-favorites-results').innerHTML = '<p>Click on the heart icon to add items to your favorites.</p>';
			return;
		}

		let favoriteString = encodeURIComponent(favorites.join(','));
		// favoriteString = favoriteString.replace(/webinar_|video_|article_|resource_|podcast_/g, "");
		console.log(favoriteString);

		const response = await window.fetch(mefa.adminAjax+"?action=getcards"+'&cards='+favoriteString, options)
			.then(response => response.text())
			.catch(error => console.error(error));

		if (response) {
			document.querySelector("#resources-favorites-results").innerHTML = response;
			let count = document.querySelectorAll("#resources-favorites-results .card").length;
			document.querySelector('#resources-favorites-stats').innerHTML = '<h2>Results ('+count+')</h2>';
		}
	}

	initMobileInterface() {
		const mobileModal = document.querySelector('.mobile-filter-modal-container');
		const mobileModalTrigger = document.querySelector('#mobile-filter-trigger');
		const mobileModalCloseBtn =  mobileModal.querySelector('button.close');
		const docHeader = document.querySelector('header.header');
		const applyFiltersBtn = document.querySelector('#mobile-apply-filters');
		let headerZ = 0;

		mobileModalTrigger.addEventListener('click', () => {
			mobileModal.classList.toggle('active');
			if (headerZ < 100) headerZ = docHeader.style.zIndex;
			docHeader.style.zIndex = 0;
		});
		mobileModalCloseBtn.addEventListener('click' , () => {
			mobileModal.classList.toggle('active');
			document.querySelector('header.header').style.zIndex = headerZ;
		});
		window.addEventListener('resize' , ()=>{
			if (mobileModal.classList.contains('active')) {
				mobileModal.classList.toggle('active');
				document.querySelector('header.header').style.zIndex = headerZ;
			}
		});


		mobileModal.querySelector('.search-input input').addEventListener('click', (e) => {
			document.querySelector('header.header').style.zIndex = headerZ;
			e.currentTarget.blur();
			mobileModal.classList.toggle('active');

		});

		applyFiltersBtn.addEventListener('click', () => {

			mobileModal.classList.toggle('active');
			document.querySelector('header.header').style.zIndex = headerZ;

		});


	}

}
